/* global PlayReadyManager */
/* global WidevineManager */
/* global NeonPlayerUtils */
/* global SkinUtils */
/* global VideoJsUtils */
/* global Dash */
/* global videojs */
/* global MediaPlayer */

var NeonPlayerDash = function () {
	var _videoElement, // This is the <video> element
		_videojsElement, //This is the video.js <div> element containing the player and controls
		_settings,
		_media,
		_licenseManager,

		createDashPlayer = function (container, settings) {
			_settings = settings;
			
			var playerArgs = {
				id: "#videoPlayer",
				width: _settings.width,
				height: _settings.height
			};
			
			var skinClass = SkinUtils.getClass(_settings.skin);

			var createPlayerElement = function (container, player) {
				var videoElement = document.createElement("video");
				videoElement.setAttribute("id", player.id.substring(1));
				videoElement.setAttribute("autoplay", "");
				videoElement.setAttribute("controls", "");
				videoElement.setAttribute("width", player.width);
				videoElement.setAttribute("height", player.height);
				videoElement.setAttribute("class", "video-js " + skinClass);

				container.appendChild(videoElement);
				return videoElement;
			};
			
			// Create video element
			_videoElement = createPlayerElement(container, playerArgs);
			if(_settings.debug) window.console && console.log("dash.js player created");
		},

		startPlayback = function (media) {
			if (_settings.debug) window.console && console.log("dash.js playback starting");
			
			_media = media;
			
			if(media.poster) {
				_videoElement.setAttribute("poster", media.poster);
			}
			
			if(!media.dashManifest) {
				throw "Dash manifest not defined. The player requires Dash for playback in the given context (browser, etc) and no manifest has been provided.";
			}
			
			var doPlayback = function () {
				var sourceElement = document.createElement("source");
				sourceElement.setAttribute("src", media.dashManifest);
				sourceElement.setAttribute("type", "application/dash+xml");
				_videoElement.appendChild(sourceElement);
				_videoElement.setAttribute("lang", media.language);

				var context = new Dash.di.DashContext();
				var player = new MediaPlayer(context);

				if (media.subtitles !== undefined && media.subtitles != {}) {
					VideoJsUtils.addTextTracks(_videoElement, media.subtitles);
				}
				
				var skinControls = SkinUtils.getControls(_settings.skin);

				_videojsElement = videojs("videoPlayer", {
					controlBar: {
						children: skinControls
					},
					context: context,
					mediaPlayer: player,
					language: _settings.language
				}, onStart);

				window.dashPlayer = _videojsElement;
				window.videoElement = _videoElement;
				window.context = context;
				
				// Control dashjs logging to console
				var dashDebugConfig = player.getDebug();
				if(dashDebugConfig) {
					dashDebugConfig.setLogToBrowserConsole(_settings.debug);
				}

				// Need to hook up the player again since the original gets destroyed by video.js.
				_videoElement = _videojsElement.el().querySelector("video");
				_videoElement.setAttribute("crossorigin", "anonymous");
				
				if(_media.encrypted) {				
					// Hook up license retrieval
					var licenseContext = { videojsElement: _videojsElement , videoElement: _videoElement, licenseData: _media}
					_licenseManager.getLicense(licenseContext);
				}
			};

			if(_media.encrypted) {
				var drm = NeonPlayerUtils.getSupportedDrm();
				if(!drm) {
					throw "Media was flagged as encrypted, but no supported DRM system is found by the player";
				}
				if (drm == NeonPlayerUtils.getLiterals().widevine) {
					_licenseManager = new WidevineManager();
				}
				if (drm == NeonPlayerUtils.getLiterals().playready) {
					_licenseManager = new PlayReadyManager();
				}
				
				_licenseManager.prepare(media.dashManifest, doPlayback);
			} else {
				doPlayback();
			}
			
			$(document).trigger("playbackEvent", {sender: "dash.js", detail: "starting"});
		},

		closeDashPlayer = function () {
			if (_videojsElement === undefined || _videojsElement.el() === null) return;

			_videojsElement.mediaPlayer.reset();
			_videojsElement.dispose();

			if (_settings.debug) window.console && console.log("dash.js player closed");
		},

		onStart = function () {
			// Enable videojs plugins
			var features = SkinUtils.getFeatures(_settings.skin);
			// Hotkeys videojs plugin for keyboard shortcuts
			if(features.indexOf("hotKeys") > -1) {
				this.hotkeys();
			}
			// Close button at the top right corner (custom)
			if(features.indexOf("closeButton") > -1) {
				this.closeButton();
			}
			// Tooltip with current time when using the progress bar
			if(features.indexOf("progressTips") > -1) {
				this.progressTips({ thumbnailsUrl: _media.thumbnails, debug: _settings.debug });
			}

			this.on("playing", function () {
				$(document).trigger("playbackEvent", {sender: "dash.js", detail: "playing"});
			});
			this.on("pause", function () {
				$(document).trigger("playbackEvent", {sender: "dash.js", detail: "paused"});
			});
			this.on("ended", function () {
				$(document).trigger("playbackEvent", {sender: "dash.js", detail: "ended"});
			});
			this.on("error", function (e) {
				var error = _videojsElement.error();
				if(error.message.indexOf("CDM LoadSession()") > 0) {
					// Spurious error thrown in Firefox on first playback that has no effect. Ignore and stop propagation
					if (_settings.debug) window.console && console.warn("Ignoring spurious Firefox widevine CDM LoadSession() error (not a real issue)");
					// Stop propagation of event
					e.stopPropagation();
					e.stopImmediatePropagation();
					e.preventDefault();
					// Remove error from videoJS
					setTimeout(function(){ _videojsElement.error(null); }, 0);
				} else {
					$(document).trigger("errorEvent", {sender: "dash.js", detail: "error"});			
				}

				
			});
			this.on("fullscreenchange", function () {
				var mode = this.isFullscreen() ? "fullscreen" : "windowed";
				$(document).trigger("fullscreenEvent", {sender: "dash.js", detail: mode});			
			});
			
			
			this.on("seeking", function () {
				// Patch for the issue in where seeking while paused never finishes seeking
				// TODO improve by pausing right after seeked if it was paused before
				this.play();
			});

			this.play();
		};

	return {
		createPlayer: function (container, options) {
			createDashPlayer(container, options);
		},

		startPlayback: function (media) {
			startPlayback(media);
		},

		play: function () {
			_videojsElement.play();
		},

		pause: function () {
			_videojsElement.pause();
		},

		close: function () {
			closeDashPlayer();
		},
			
		seek: function (seconds) {
			_videojsElement.currentTime(seconds);
		},
		
		getCurrentTime: function () {
			return _videojsElement.currentTime();
		},
		
		getDuration: function () {
			return _videojsElement;
		}
	};
};
